import backend, {METRICS_API} from 'utils/backend/server/api_library';

import queryString from 'query-string';

const getMetricsUrl = (path, queryParam) => {
  if (!METRICS_API) {
    throw new Error('REACT_APP_METRICS_API is not configured.');
  }

  const query = queryString.stringify(queryParam);

  return `${METRICS_API}${path}?${query}`;
};

const queryDailyClientMetrics = (dates) => {
  const url = getMetricsUrl('/metrics/client/daily_count', {
    dates: dates.join(','),
  });
  return backend.get(url);
};

const queryDailyClientLogsMetrics = (dates) => {
  const url = getMetricsUrl('/metrics/client/daily_logs', {
    dates: dates.join(','),
  });
  return backend.get(url);
};

export default {
  queryDailyClientMetrics,
  queryDailyClientLogsMetrics,
};
